import { format } from 'date-fns';

export function formatMoney(amount?: number): string {
  if (amount === null || amount === undefined) {
    return '';
  }

  return amount.toLocaleString('no-NO');
}

export function formatAmountWithThousandSeparator(
  value: number | string | null,
): string {
  if (!value) {
    return '';
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export const formatNumber = (val: number | string): string => {
  return val?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

/**
 * parse a formatted number, return it as a string
 * @param val value as string or number
 * @returns number as string
 */
export const parseFormattedNumber = (val: string | number): string => {
  const valWithoutSpaces = val.toString().replace(/\s/g, '');

  const parsedNumber = parseInt(valWithoutSpaces, 10);

  if (Number.isNaN(parsedNumber)) {
    return '';
  }

  return parsedNumber.toString();
};

export const removeWhitespaceAndConvertToNumber = (input: string): number => {
  const stringWithoutWhitespace = input.replace(/\s/g, '');
  const numberValue = parseFloat(stringWithoutWhitespace);
  return numberValue;
};

export function formatDate(date: string): string {
  return date ? format(new Date(date), 'dd.MM.yyyy') : date;
}

export const getCapitlizedString = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
